import { render, staticRenderFns } from "./CustomLinks.vue?vue&type=template&id=cba0df1e&scoped=true"
import script from "./CustomLinks.vue?vue&type=script&lang=js"
export * from "./CustomLinks.vue?vue&type=script&lang=js"
import style0 from "./CustomLinks.vue?vue&type=style&index=0&id=cba0df1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba0df1e",
  null
  
)

export default component.exports